import cn from 'classnames'
import React from 'react'

import useHoveredItem from '@/common/hooks/useHoveredItem'
import useI18n from '@/common/hooks/useI18n'
import NearbyPlaceDetail from '@/modules/property/pages/PlaceDetailPage/components/NearbyPlaceDetail'
import { NO_NEARBY_PLACES } from '@/modules/property/pages/PlaceDetailPage/translation'

import { Wrapper } from './styled'

interface NearbyPlaceDetailListProps {
  nearbyPlaces: RentAPerfect.NearbyPlace[]
}

const NearbyPlaceDetailList = ({
  nearbyPlaces,
}: NearbyPlaceDetailListProps) => {
  const { t } = useI18n()
  const { hovered, getElementProps: getHoveredItemProps } = useHoveredItem()

  return (
    <Wrapper
      className={cn(!nearbyPlaces.length && 'flex align-center justify-center')}
    >
      {nearbyPlaces.length ? (
        nearbyPlaces.map(nearbyPlace => (
          <NearbyPlaceDetail
            key={`nearby-place-${nearbyPlace.id}`}
            className='p-12 clickable'
            nearbyPlace={nearbyPlace}
            selected={hovered === nearbyPlace.id}
            {...getHoveredItemProps(nearbyPlace.id)}
          />
        ))
      ) : (
        <div>{t(NO_NEARBY_PLACES)}</div>
      )}
    </Wrapper>
  )
}

export default NearbyPlaceDetailList
